"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrillTargetDashboardItem = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2023 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var sdk_model_1 = require("@gooddata/sdk-model");
var model_1 = require("../../../../../model");
var dashboardList_1 = require("../../../../dashboardList");
var buildDashboardItems = function (dashboards, forbiddenDashboards, intl, selected) {
    var isAvailableDashboardSelected = dashboards.some(function (dashboard) {
        return sdk_model_1.areObjRefsEqual(dashboard.ref, selected);
    });
    if (!selected || isAvailableDashboardSelected) {
        return dashboards;
    }
    var selectedForbiddenItem = forbiddenDashboards.find(function (_a) {
        var ref = _a.ref;
        return sdk_model_1.areObjRefsEqual(ref, selected);
    });
    if (selectedForbiddenItem === undefined) {
        return dashboards;
    }
    var title = selectedForbiddenItem.title, accessibilityLimitation = selectedForbiddenItem.accessibilityLimitation;
    var forbiddenItem = tslib_1.__assign(tslib_1.__assign({}, selectedForbiddenItem), { title: accessibilityLimitation === "forbidden"
            ? intl.formatMessage({ id: "configurationPanel.drillConfig.forbiddenDashboard" })
            : title });
    return tslib_1.__spread([forbiddenItem], dashboards);
};
exports.DrillTargetDashboardItem = function (props) {
    var onSelect = props.onSelect, selected = props.selected;
    var intl = react_intl_1.useIntl();
    var dashboards = model_1.useDashboardSelector(model_1.selectAccessibleDashboards);
    var inaccessibleDashboards = model_1.useDashboardSelector(model_1.selectInaccessibleDashboards);
    var dashboardItems = react_1.useMemo(function () {
        return buildDashboardItems(dashboards, inaccessibleDashboards, intl, selected);
    }, [dashboards, inaccessibleDashboards, intl, selected]);
    return react_1.default.createElement(dashboardList_1.DashboardList, { onSelect: onSelect, dashboards: dashboardItems, selected: selected });
};
//# sourceMappingURL=DrillTargetDashboardItem.js.map